import { render, staticRenderFns } from "./Identity-setting-Drawer.vue?vue&type=template&id=f9adaac4";
import script from "./Identity-setting-Drawer.vue?vue&type=script&lang=js";
export * from "./Identity-setting-Drawer.vue?vue&type=script&lang=js";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, null, null);
export default component.exports;